import React from 'react'
import contactsImage from 'images/contacts.png'
import EventPage from 'organization/Event/EventPage'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import styled from 'styled-components'
import {FAQ} from 'organization/Event/Help/FAQ'
import {useI18n} from 'i18n/I18nContext'

export function Help() {
  const {t} = useI18n()
  return (
    <EventPage>
      <div className="row pl-30 pb-30 pr-30">
        <BreadcrumMenu title={t('orgHelp.breadcrumb')} />

        <div className="col-xxl-12">
          <div className="create__event-area">
            <div className="body__card-wrapper">
              {/* create event form  */}

              <Title className="mb-35">{t('orgHelp.faqTitle')}</Title>

              <FAQ />

              <Title className="mb-35 mt-80">{t('orgHelp.contactTitle')}</Title>

              <div className="row g-4">
                <div className=" col-12 col-lg-6">
                  <img src={contactsImage} width="100%" alt="" />
                </div>

                <div className="col-12 col-lg-6">
                  <ul className="contact_info_list style_2 ps-lg-4 unordered_list_block">
                    <li>
                      <strong>{t('orgHelp.phoneLabel')}</strong>
                      {t('orgHelp.phoneHidden')}
                    </li>
                    <li>
                      <strong>{t('orgHelp.emailLabel')}</strong>
                      <a
                        href="mailto:support@eventa.tv"
                        target="_blank"
                        rel="noreferrer"
                      >
                        support@eventa.tv
                      </a>
                    </li>
                    <li>
                      <strong>{t('orgHelp.hoursLabel')}</strong>
                      <span>{t('orgHelp.hoursValue')}</span>
                    </li>
                    <li>
                      <strong>{t('orgHelp.followUs')}</strong>
                      <div className="social_icon unordered_list">
                        <div className={'footer__social'}>
                          <a
                            href="https://www.facebook.com/eventatv"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="facebook"
                          >
                            <i className="fa-brands fa-facebook"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </EventPage>
  )
}

const Title = styled.div`
  color: var(--clr-text-secondary);
  font-weight: bold;
  font-size: 2rem;
`
